import { cva, type VariantProps } from 'class-variance-authority'
import type React from 'react'
import { createElement } from 'react'

import { cn } from '@/legacy-src/lib/utils'

const containerVariants = cva('mx-auto w-full px-5', {
  variants: {
    width: {
      sm: 'max-w-[720px]',
      md: 'max-w-[970px]',
      lg: 'max-w-[1180px]',
      xl: 'max-w-[1300px]',
    },
  },
  defaultVariants: { width: 'lg' },
})

export interface ContainerProps<T extends keyof JSX.IntrinsicElements> extends VariantProps<typeof containerVariants> {
  element?: T
  className?: string
  children: React.ReactNode
}

export const Container = <T extends keyof JSX.IntrinsicElements>({
  element,
  width,
  className,
  children,
}: ContainerProps<T>) =>
  createElement(
    element ?? 'div',
    {
      className: cn(containerVariants({ width, className })),
    },
    children,
  )

export default Container
